import { render } from "./AutomationJourney.vue?vue&type=template&id=daf24d30"
import script from "./AutomationJourney.vue?vue&type=script&lang=js"
export * from "./AutomationJourney.vue?vue&type=script&lang=js"

import "./AutomationJourney.vue?vue&type=style&index=0&id=daf24d30&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__